import { SERIE_STACK, SERIE_TYPE } from "../tt-ui-chart/ChartOptions"
import { SERIE_TYPES } from "../types"

/** Chart-config serie type → the Highcharts series type it renders as. */
export function convertChartTypeToHighcharts(chartType: `${SERIE_TYPES}`): `${SERIE_TYPE}` {
  switch (chartType) {
    case SERIE_TYPES.BAR_STACKED:
    case SERIE_TYPES.BAR_UNSTACKED:
      return SERIE_TYPE.COLUMN
    case SERIE_TYPES.AREA_STACKED:
    case SERIE_TYPES.AREA_UNSTACKED:
      return SERIE_TYPE.AREA
    default:
      return SERIE_TYPE.LINE
  }
}

/** Highcharts stacking mode for a serie type — only the stacked variants
 * stack, as `percent` when the chart is in percent-share display mode. */
export function getStack(
  serieType: `${SERIE_TYPES}`,
  isPercentageShare: boolean,
): `${SERIE_STACK}` | undefined {
  if (serieType !== SERIE_TYPES.BAR_STACKED && serieType !== SERIE_TYPES.AREA_STACKED) {
    return undefined
  }

  return isPercentageShare ? SERIE_STACK.PERCENTAGE : SERIE_STACK.NORMAL
}
